import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ISetDatasourceNlpSettingParams {
  id: string;
  nlpOption: string;
}

export class SetDatasourceNlpSettingRequest extends Request<ISetDatasourceNlpSettingParams, IEmptyResult> {
  constructor(params: ISetDatasourceNlpSettingParams) {
    super('setDatasourceNlpSetting', params);
  }
}
